import ManagementsUpdateContact from "../../components/ManagementsUpdate/ManagementsUpdateContact/ManagementsUpdateContact";

function ManagementsUpdateContactPage() {
  return <ManagementsUpdateContact />;
}

export default ManagementsUpdateContactPage;
